import { type MetricConfiguration } from "@tokenterminal/tt-analytics-api-types/dist/api/metrics"
import { type ProjectMeta } from "@tokenterminal/tt-analytics-api-types/dist/api/projects"
import { POSSIBLE_METRICS_ENUM } from "data/metric-configuration"

export function getMetricLabel(
  config: Pick<MetricConfiguration, "metric_id" | "title" | "short_title">,
  projectInfo?: Pick<ProjectMeta, "symbol">
): string {
  if (config.metric_id === POSSIBLE_METRICS_ENUM.TOKEN_TRADING_VOLUME) {
    return getTokenTradingVolumeLabel(projectInfo?.symbol)
  }

  if (config.metric_id === POSSIBLE_METRICS_ENUM.TOKENHOLDERS) {
    return getTokenholdersLabel(config.title, projectInfo?.symbol)
  }

  return config.title
}

export function getTokenTradingVolumeLabel(symbol?: ProjectMeta["symbol"]) {
  return `${symbol ? symbol : "Token"} trading volume`
}

export function getTokenholdersLabel(
  title: MetricConfiguration["title"],
  symbol?: ProjectMeta["symbol"]
) {
  if (!symbol) {
    return title
  }

  return `${symbol} ${title.toLowerCase()}`
}
